import { pageSettingsType } from 'types/pages/pageContainer.types';
import {
  RetirementGlossaryTerm,
  retirementGlossaryTermType,
} from 'humanity/pages/retirementGlossaryTerm';
import { PageContainer } from 'humanity/pages/pageContainer';
import { getRetirementGlossaryTermSSG } from 'humanity/pages/retirementGlossaryTerm/retirementGlossaryTerm.query';
import { RETIREMENT_GLOSSARY_SLUG } from 'pages/learn/retirement-glossary';
import { getAllPageSlugsPaths } from 'lib/contentful';

const RetirementGlossaryPage = ({ pageSettings, pageContent }) => (
  <PageContainer
    layout={pageSettings.layout}
    notes={pageContent.notesCollection?.items}
    disclosures={pageContent.disclosuresCollection?.items}
    seoMetadata={pageSettings.seoMetadata}
  >
    <RetirementGlossaryTerm
      title={pageContent.title}
      sections={pageContent.sectionsCollection?.items}
    />
  </PageContainer>
);

RetirementGlossaryPage.propTypes = {
  pageSettings: pageSettingsType.isRequired,
  pageContent: retirementGlossaryTermType.isRequired,
};

export const getStaticProps = getRetirementGlossaryTermSSG(
  `${RETIREMENT_GLOSSARY_SLUG}/`
);

export const getStaticPaths = async () => {
  const paths = await getAllPageSlugsPaths(RETIREMENT_GLOSSARY_SLUG);
  return { paths, fallback: 'blocking' };
};

export default RetirementGlossaryPage;
